<template>
    <el-dialog title="小程序签到二维码" :visible.sync="dialogVisible" append-to-body>
        <div style="text-align: center;">
            <div style="padding: 0 0 20px; font-size: 30px;">{{ row.name }} 活动签到二维码</div>
            <a :href="src" download="二维码" target="_blank" title="右键下载">
                <el-image v-if="src" :src="src" class="image"></el-image>
                <div>点击下载 或 右键下载图片</div>
            </a>
            <div style="padding: 20px 0 10px; font-size: 20px;">活动时间：{{ row.act_starttime }} 到 {{ row.act_endtime }}</div>
            <div style="font-size: 20px;">活动地点：{{ details.address }}</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="handleCloseDialog">取 消</el-button> -->
            <el-button type="primary" @click="handleCloseDialog">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { actview } from "@/api/tiezi";
    import { getMiniAppQrcode } from '@/api/huodongguanliBaomingjilu'

    export default {
        data() {
            return {
                dialogVisible: false,
                row: {},
                details: {},

                query: {
                    // token: sessionStorage.getItem("token"),
                    // id: '',
                    path: 'pages/home/home',
                    env: 'release',
                    scene: ''
                },
                src: ''
            }
        },
        created() {},
        methods: {
            handleOpenDialog(row) {
                this.row = row;
                this.query.scene = `id=${row.id}&type=xiehuihuodong`;
                this.huodongxiangqing();
                this.getDetail();
                this.dialogVisible = true;
            },
            handleCloseDialog() {
                this.dialogVisible = false;
            },

            huodongxiangqing() {
                const obj = {
                    token: sessionStorage.getItem("token"),
                    id: this.row.id,
                };
                actview(obj).then(({ data: res }) => {
                    this.details = res;
                });
            },

            getDetail() {
                getMiniAppQrcode(this.query).then(({ data: res }) => {
                    this.src = res.data.url;
                })
            },
        }
    }
</script>

<style lang="less" scope>
    .image {
        display: block;
        width: 400px;
        height: 400px;
        margin: 0 auto;
    }
</style>